import Vue from 'vue'

export default Vue.directive('input-auto-width', {
  inserted: function (el: HTMLElement, binding, vnode) {
    resizeWidthByValue(el, (el as HTMLInputElement).value)

    /**
     * onWatch 에서 호출합니다.
     */
    ;(el as any)._inputAutoWidth = (text: string) => {
      resizeWidthByValue(el, text)
    }
  },
  unbind(el: HTMLElement) {
    delete (el as any)._inputAutoWidth
  },
})

function resizeWidthByValue(el: any, text?: string) {
  let target: HTMLInputElement = el
  let value: string = text || target.placeholder
  const model: HTMLDivElement = document.createElement('div')
  model.style.height = '0px'
  model.style.minWidth = target.style.minWidth
  model.style.opacity = '0'
  model.style.position = 'fixed'
  model.style.left = '-9999px'
  model.style.display = 'flex'
  model.innerHTML = value
  document.body.appendChild(model)
  target.style.width = model.offsetWidth + 28 + 'px'
  document.body.removeChild(model)

  if (target.parentElement && target.parentElement.parentElement) {
    const scrollDiv = target.parentElement.parentElement
    scrollDiv.scrollLeft = scrollDiv.scrollWidth
  }
}
